import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListadoCronogramasComponent } from './cronogramas/listado-cronogramas/listado-cronogramas.component';
import { CrearEditarCronogramaComponent } from './cronogramas/crear-editar-cronograma/crear-editar-cronograma.component';
import { ListadoColectivosComponent } from './colectivos/listado-colectivos/listado-colectivos.component';
import { CrearEditarColectivoComponent } from './colectivos/crear-editar-colectivo/crear-editar-colectivo.component';
import { ListadoRecordatoriosComponent } from '../../standalone/recordatorios/listado-recordatorios/listado-recordatorios.component';
import { ListadoRecorridosComponent } from './recorridos/listado-recorridos/listado-recorridos.component';
import { CrearEditarRecorridoComponent } from './recorridos/crear-editar-recorrido/crear-editar-recorrido.component';

import { MapaColectivosComponent } from './mapa-colectivos/mapa-colectivos.component';
import { ListadoModelosDispositivosComponent } from '../../standalone/modelos-dispositivos/listado-modelos-dispositivos/listado-modelos-dispositivos.component';
import { CrearEditarModeloDispositivoComponent } from '../../standalone/modelos-dispositivos/crear-editar-modelo-dispositivo/crear-editar-modelo-dispositivo.component';
import { ListadoCodigosDispositivoComponent } from '../../standalone/codigos-dispositivos/listado-codigos-dispositivos/listado-codigos-dispositivos.component';
import { CrearEditarCodigosDispositivosComponent } from '../../standalone/codigos-dispositivos/crear-editar-codigos-dispositivos/crear-editar-codigos-dispositivos.component';
import { ListadoGruposComponent } from '../../standalone/grupos/listado-grupos/listado-grupos.component';
import { CrearEditarUbicacionComponent } from '../../standalone/ubicaciones/crear-editar-ubicacion/crear-editar-ubicacion.component';
import { ListadoUbicacionesComponent } from '../../standalone/ubicaciones/listado-ubicaciones/listado-ubicaciones.component';
import { DetallesColectivoComponent } from './colectivos/detalles-colectivo/detalles-colectivo.component';
import { ListadoChoferesComponent } from '../../standalone/choferes/listado-choferes/listado-choferes.component';
import { DespachosComponent } from './despachos/despachos/despachos.component';
import { ListadoProveedoresComponent } from '../../standalone/proveedores/listado-proveedores/listado-proveedores';
import { ListadoServiciosComponent } from '../../standalone/servicios/listado-servicios/listado-servicios.component';
import { CrearEditarServicioComponent } from '../../standalone/servicios/crear-editar-servicio/crear-editar-servicio.component';
import { CrearEditarRecordatorioComponent } from '../../standalone/recordatorios/crear-editar-recordatorio/crear-editar-recordatorio.component';

const routes: Routes = [
  // Mapa
  {
    path: 'mapaColectivos',
    title: 'Mapa de colectivos',
    component: MapaColectivosComponent,
    canActivate: [],
  },
  // Choferes
  {
    path: 'choferes',
    title: 'Choferes',
    component: ListadoChoferesComponent,
    canActivate: [],
  },
  // Cronogramas
  {
    path: 'cronogramas',
    title: 'Recordatorios',
    component: ListadoCronogramasComponent,
    canActivate: [],
  },
  {
    path: 'cronogramas/crear',
    title: 'Nuevo recordatorio',
    component: CrearEditarCronogramaComponent,
    canActivate: [],
  },
  {
    path: 'cronogramas/editar/:id',
    title: 'Editar recordatorio',
    component: CrearEditarCronogramaComponent,
    canActivate: [],
  },
  // Despachos
  {
    path: 'despachos',
    title: 'Despachos',
    component: DespachosComponent,
    canActivate: [],
  },

  // Lineas
  {
    path: 'grupos/:categoria',
    title: 'Líneas',
    component: ListadoGruposComponent,
    canActivate: [],
  },
  // Colectivos
  {
    path: 'colectivos',
    title: 'Colectivos',
    component: ListadoColectivosComponent,
    canActivate: [],
  },
  {
    path: 'colectivos/crear',
    title: 'Nuevo colectivo',
    component: CrearEditarColectivoComponent,
    canActivate: [],
  },
  {
    path: 'colectivos/editar/:id',
    title: 'Editar colectivo',
    component: CrearEditarColectivoComponent,
    canActivate: [],
  },
  {
    path: 'colectivos/detalles/:id',
    title: 'Colectivo',
    component: DetallesColectivoComponent,
    canActivate: [],
  },
  // Proveedores
  {
    path: 'proveedores/:categoria',
    title: 'Proveedores',
    component: ListadoProveedoresComponent,
    canActivate: [],
  },

  // Recordatorios
  {
    path: 'recordatorios/:categoria',
    title: 'Recordatorios',
    component: ListadoRecordatoriosComponent,
    canActivate: [],
  },

  {
    path: 'recordatorios/:categoria/crear',
    title: 'Nuevo recordatorio',
    component: CrearEditarRecordatorioComponent,
    canActivate: [],
  },

  {
    path: 'recordatorios/:categoria/editar/:id',
    title: 'Editar recordatorio',
    component: CrearEditarRecordatorioComponent,
    canActivate: [],
  },

  // Recorridos
  {
    path: 'recorridos',
    title: 'Recorridos',
    component: ListadoRecorridosComponent,
    canActivate: [],
  },
  {
    path: 'recorridos/crear',
    title: 'Nuevo recorrido',
    component: CrearEditarRecorridoComponent,
    canActivate: [],
  },
  {
    path: 'recorridos/editar',
    title: 'Editar recorrido',
    component: CrearEditarRecorridoComponent,
    canActivate: [],
  },
  // Servicios
  {
    path: 'servicios/:categoria',
    title: 'Proveedores',
    component: ListadoServiciosComponent,
    canActivate: [],
  },
  {
    path: 'servicios/:categoria/crear',
    title: 'Nuevo proveedor',
    component: CrearEditarServicioComponent,
    canActivate: [],
  },
  {
    path: 'servicios/:categoria/editar/:id',
    title: 'Editar proveedor',
    component: CrearEditarServicioComponent,
    canActivate: [],
  },

  // Terminales
  {
    path: 'ubicaciones/:categoria',
    title: 'Terminales',
    component: ListadoUbicacionesComponent,
    canActivate: [],
  },
  {
    path: 'ubicaciones/:categoria/crear',
    title: 'Nueva terminal',
    component: CrearEditarUbicacionComponent,
    canActivate: [],
  },
  {
    path: 'ubicaciones/:categoria/editar/:id',
    title: 'Editar terminal',
    component: CrearEditarUbicacionComponent,
    canActivate: [],
  },
  // Modelos Dispositivos
  {
    path: 'modelosDispositivos/:tipo',
    title: 'Modelos de dispositivos',
    component: ListadoModelosDispositivosComponent,
    canActivate: [],
  },
  {
    path: 'modelosDispositivos/:tipo/crear',
    title: 'Nuevo modelo',
    component: CrearEditarModeloDispositivoComponent,
    canActivate: [],
  },
  {
    path: 'modelosDispositivos/:tipo/editar/:id',
    title: 'Editar modelo',
    component: CrearEditarModeloDispositivoComponent,
    canActivate: [],
  },
  // Codigos Dispositivos
  {
    path: 'codigosDispositivos/:tipo',
    title: 'Códigos de dispositivos',
    component: ListadoCodigosDispositivoComponent,
    canActivate: [],
  },
  {
    path: 'codigosDispositivos/:tipo/crear',
    title: 'Nuevo código',
    component: CrearEditarCodigosDispositivosComponent,
    canActivate: [],
  },
  {
    path: 'codigosDispositivos/:tipo/editar/:id',
    title: 'Editar código',
    component: CrearEditarCodigosDispositivosComponent,
    canActivate: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ColectivosRoutingModule {}
